export default "/images/tool.svg?323a64cdb598c90a3b8760eb6a2941c8";